import { Directive, ElementRef, Renderer2, Injector, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
export class UploadFileDirective implements OnInit {

    control: NgControl;
/**
 * @param {?} _er
 * @param {?} inj
 * @param {?} render
 */
constructor(
private _er: ElementRef,
private inj: Injector,
private render: Renderer2
    ) {
        this.render.setStyle(this._er.nativeElement, 'display', 'none');
    }
/**
 * @return {?}
 */
click() {
        this._er.nativeElement.click();
    }
/**
 * @return {?}
 */
ngOnInit() {
        this.control = this.inj.get(NgControl);
    }
/**
 * @param {?} value
 * @return {?}
 */
setValue(value) {
        this.control.control.setValue(value);
    }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[hdUploadFile]',
  exportAs: 'hdUploadFile'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Injector, },
{type: Renderer2, },
];
}

function UploadFileDirective_tsickle_Closure_declarations() {
/** @type {?} */
UploadFileDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
UploadFileDirective.ctorParameters;
/** @type {?} */
UploadFileDirective.prototype.control;
/** @type {?} */
UploadFileDirective.prototype._er;
/** @type {?} */
UploadFileDirective.prototype.inj;
/** @type {?} */
UploadFileDirective.prototype.render;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
